.reports-page {
  max-width: 1040px;
}

.section {
  margin-bottom: 32px;

  .section-header {
    margin-top: 0;
    font-weight: 400;
  }
}
.section:last-child {
  margin-bottom: 0;
}

.section-details {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 16px;
}

.section-detail {
  & > a,
  & > p {
    font-size: 16px;
  }
  & > p {
    line-height: 1.5;
    margin: 4px 0 0;
  }
}
